import gql from 'graphql-tag';

export const GET_WHATSAPP_TEMPLATES = gql`
    query GetTemplates($employee_id: Int!) {
        getWhatsAppTemplates(employee_id: $employee_id) {
            success
            data {
                id
                template_name
                status
                components
            }
        }
    }
`;

export const SEND_WHATSAPP_TEMPLATE = gql`
    mutation SendTemplate(
        $employee_id: Int!, 
        $mobile: String!, 
        $name: String, 
        $template_id: Int!, 
        $variables: [String]
    ) {
        sendWhatsAppTemplate(
            employee_id: $employee_id,
            mobile: $mobile,
            name: $name,
            template_id: $template_id,
            variables: $variables
        ) {
            success
            message
        }
    }
`;

export const SEND_WHATSAPP_MESSAGE = gql`
    mutation SendMessage(
        $employee_id: Int!, 
        $mobile: String!, 
        $message: String!, 
        $type: String!, 
        $media_url: String,
        $name: String
    ) {
        sendWhatsAppMessage(
            employee_id: $employee_id,
            mobile: $mobile,
            message: $message,
            type: $type,
            media_url: $media_url,
            name: $name
        ) {
            success
            message
        }
    }
`;

export const GET_WHATSAPP_CONTACTS = gql`
    query GetInbox($employee_id: Int!, $page: Int, $limit: Int, $search: String) {
        getWhatsAppContacts(employee_id: $employee_id, page: $page, limit: $limit, search: $search) 
    }
`;

export const GET_WHATSAPP_TAGS = gql`
    query GetTags($employee_id: Int!) {
        getWhatsAppTags(employee_id: $employee_id) {
            success
            message
            data {
                id
                tag_name
            }
        }
    }
`;

export const CREATE_WHATSAPP_CONTACT = gql`
    mutation CreateContact(
        $employee_id: Int!, 
        $mobile: String!, 
        $name: String!, 
        $tag_id: String,
        $email: String,
        $branch_id: Int
    ) {
        createWhatsAppContact(
            employee_id: $employee_id,
            mobile: $mobile,
            name: $name,
            tag_id: $tag_id,
            email: $email,
            branch_id: $branch_id
        ) {
            success
            message
            data {
                wa_contact_id
                isNew
            }
        }
    }
`;

export const GET_WHATSAPP_CHATS = gql`
    query GetChatHistory($employee_id: Int!, $mobile: String!, $page: Int, $limit: Int) {
        getWhatsAppChats(employee_id: $employee_id, mobile: $mobile, page: $page, limit: $limit)
    }
`;

export const GET_WHATSAPP_TIMELINE = gql`
    query GetTimeline($employee_id: Int!, $mobile: String!, $page: Int, $limit: Int) {
        getWhatsAppTimeline(employee_id: $employee_id, mobile: $mobile, page: $page, limit: $limit)
    }
`;

export const GET_WHATSAPP_LEAD_TIMELINE = gql`
    query GetLeadTimeline($employee_id: Int!, $mobile: String, $wa_contact_id: Int) {
        getWhatsAppLeadTimeline(employee_id: $employee_id, mobile: $mobile, wa_contact_id: $wa_contact_id)
    }
`;

export const GET_WHATSAPP_LEADS = gql`
    query GetLeads($employee_id: Int!) {
        getWhatsAppLeads(employee_id: $employee_id)
    }
`;

export const UPDATE_WHATSAPP_LEAD_HISTORY = gql`
    mutation UpdateHistory(
        $employee_id: Int!, 
        $wa_contact_id: Int!, 
        $lead_status_type_id: Int, 
        $calling_status_id: Int, 
        $followup_time: String, 
        $comments: String
    ) {
        updateWhatsAppLeadHistory(
            employee_id: $employee_id, 
            wa_contact_id: $wa_contact_id, 
            lead_status_type_id: $lead_status_type_id, 
            calling_status_id: $calling_status_id, 
            followup_time: $followup_time, 
            comments: $comments
        ) {
            success
            message
        }
    }
`;

export const GET_WHATSAPP_LEAD_LEVELS = gql`
    query GetLeadLevels {
        getWhatsAppLeadLevels
    }
`;

export const GET_WHATSAPP_CALL_STATUS_TYPES = gql`
    query GetCallStatusTypes {
        getWhatsAppCallStatusTypes
    }
`;

export const GET_WHATSAPP_LEAD_STATUS_TYPES = gql`
    query GetLeadStatusTypes($employee_id: Int!) {
        getWhatsAppLeadStatusTypes(employee_id: $employee_id)
    }
`;

export const GET_BRANCHES = gql`
    query GetBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
        }
    }
`;
